module.exports = __webpack_public_path__ + "static/media/habitat-officers-build.69f2f4f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/habitat-officers-build.png
// module id = 85
// module chunks = 0